<template>
  <div class="">
    <div class="bg-white pt-3 border rounded shadow-sm text-start p-4">
      <div class="">
        <h3 class="text-l font-bold mb-4">
          {{ role.name }}
        </h3>
        <div class="">
          <label class="block text-sm leading-5 ">Name</label>
          <input type="text" v-model="name" :class="inputClass" placeholder="Role name"/>
        </div>
        <div class="my-3">
          <label class="block text-sm leading-5 mb-1">Description</label>
          <textarea v-model="description" :class="inputClass" placeholder="Describe..."></textarea>
        </div>

        <div class="mt-6 text-right">
          <button type="submit" v-on:click="updateRole" v-if="$store.getters.can('update_roles')"
                  class="py-2 px-4 bg-teal-500 hover:bg-teal-700 font-semibold text-white hover:border-transparent">
            Updated
          </button>
        </div>
      </div>
    </div>

    <div class="bg-white pt-3 mt-4 border rounded shadow-sm text-start p-4">
      <div class="">
        <h3 class="text-l font-bold mb-4">
          Permission allowed
        </h3>

        <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div v-for="permission in permissions" v-bind:key="permission.id">
            <label class="block">
              <input class="mr-2 leading-tight" type="checkbox" :value="permission.identifier"
                     :disabled="!$store.getters.can('edit_roles')"
                     @click="assignPermission(permission.identifier, checkedPermissions.includes(permission.identifier) ?'deletion':'addition')"
                     v-model="checkedPermissions">
              <span class="text-sm" :class="$store.getters.can(permission.identifier) ?'':''">{{
                  permission.name
                }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import GraphQl from "@/services/graphql.service";

export default {
  name: "RoleComponent",
  components: {},
  props: {
    id: String
  },
  data() {
    return {
      role: Object,
      loading: false,
      name: '',
      role_type: 'r',
      description: '',
      permissions: [],
      checkedPermissions: [],
      errors: [],
      inputClass: 'appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500'
    }
  },
  mounted() {
    this.getRole()
    this.getPermissions()
  },
  watch: {
    errors: function (errors) {
      this.$root.$emit("alert_error", errors);
    }
  },
  methods: {
    getRole() {
      GraphQl.sendRequest('{role(id:"' + this.id + '") {id name description created_at permissions{identifier}}}')
          .then(response => {
            this.role = response.role;
            this.name = this.role.name;
            this.description = this.role.description;
            response.role.permissions.forEach(permission => {
                  this.checkedPermissions.push(permission.identifier)
                }
            )
          })
    },
    updateRole() {
      if (!this.$store.getters.can('update_roles')) {
        this.errors.push("Not allowed to update role details.");
      }
      this.loading = true;
      this.errors = [];
      if (this.name == null || this.name === '')
        this.errors.push("Role name field is required.");
      if (this.errors.length > 0) {
        this.loading = false;
        return;
      }

      let params = 'id: "' + this.role.id + '",name: "' + this.name + '", description: "' + this.description + '",role_type: "' + this.role_type + '"';
      GraphQl.sendRequest('mutation{updateRole(' + params + ') {code message}}')
          .then(response => {
            console.log(response)
          })
    },
    assignPermission(permissionIdentifier, action) {
      if (!this.$store.getters.can('update_roles')) {
        this.errors.push("Not allowed to change role permissions");
        return;
      }
      let params = 'action: "' + action + '",permissionIdentifier: "' + permissionIdentifier + '", roleId: "' + this.id + '"';
      GraphQl.sendRequest('mutation{assignPermission(' + params + ') {code message}}')
          .then(response => {
            console.log(response)
          })
    },
    getPermissions() {
      GraphQl.sendRequest('{permissions {id name identifier description}}')
          .then(response => {
            this.permissions = response.permissions;
          })
    }
  }
}
</script>

<style scoped>
</style>